import { createSelector } from 'reselect';
import lodash from 'lodash';
import getFilteredRootCategory from './getFilteredRootCategory';

export default createSelector([getFilteredRootCategory], filteredRootCategory => {
  let totalItemCount = 0;

  lodash.get(filteredRootCategory, 'subCategories', []).forEach(subCategory => {
    totalItemCount += subCategory.items.length;
  });

  return totalItemCount;
});
